import React from 'react'
import ProductSectionForm, {
  ProductSectionFormProps,
} from 'ui-shared/Forms/ProductSectionForm'

type Props = Omit<ProductSectionFormProps, 'entity'>

const EventPackageSectionForm: React.FC<Props> = (props) => {
  return <ProductSectionForm {...props} entity="eventpackages" />
}

export default EventPackageSectionForm
